// import React, { useState } from "react";
// import { ArrowUpRight } from "lucide-react";

// const features = [
//   {
//     id: "01",
//     title: "End-to-End System Implementation",
//     desc: "Full-cycle ERP deployment from planning through go-live. We manage every phase — scoping, configuration, data migration, testing, and training — so your team transitions without disruption.",
//   },
//   {
//     id: "02",
//     title: "Strategic Process Consulting",
//     desc: "Expert guidance to align Infor capabilities with your unique business workflows. We map your operations, identify gaps, and design a solution blueprint built for long-term scalability.",
//   },
//   {
//     id: "03",
//     title: "24/7 Managed Support Services",
//     desc: "Round-the-clock monitoring, maintenance, and helpdesk for uninterrupted operations. Our dedicated team ensures your systems run at peak performance every hour of every day.",
//   },
// ];

// export default function Portfolio() {
//   const [active, setActive] = useState("01");

//   return (
//     <section className="w-full py-12 md:py-12 px-4 sm:px-6 lg:px-8" style={{background: "linear-gradient(to left,#c11e38, #220b34)"}}>
//       <div className="max-w-7xl mx-auto">
//               {/* Label */}
//         <div className="flex items-center gap-3 mb-4">
//           <span
//             className="inline-block w-8 h-[3px] rounded-full"
//             style={{ backgroundColor: "#ffffff" }}
//           />
//           <span
//             className="text-xs font-bold tracking-[0.2em] uppercase"
//             style={{ color: "#ffffff" }}
//           >
//             Our Portfolio
//           </span>
//         </div>
      
//       {/* Header */}
//       <div className="mb-12">
//         <h2 className="text-3xl sm:text-3xl md:text-4xl font-semibold leading-[1.15] mb-6" style={{ color: "#ffffff" }}>
//           PT KCS Tech Infor Services Portfolio
//         </h2>
//         <p className="text-sm sm:text-lg leading-relaxed max-w-6xl" style={{ color: "#ffffff" }}>
//           Unlock the full potential of your enterprise with our comprehensive suite
//           of Infor services — tailored ERP systems that drive efficiency and growth.
//         </p>
//       </div>

//       {/* Accordion and Image - Side by Side */}
//       <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
        
//         {/* Left: Accordion - 50% width */}
//         <div className="lg:w-1/2">
//           {features.map((f) => {
//             const isActive = active === f.id;
//             return (
//               <button
//                 key={f.id}
//                 onClick={() => setActive(f.id)}
//                 className="w-full text-left border-b py-5 transition-all duration-300 focus:outline-none"
//                 style={{ borderColor: "rgba(0,0,0,0.08)" }}
//               >
//                 <div className="flex items-center justify-between gap-4">
//                   <div className="flex items-center gap-4">
//                     <span
//                       className="text-lg font-bold tabular-nums transition-colors duration-300"
//                       style={{ color: isActive ? "#ffffff" : "#ffffff" }}
//                     >
//                       {f.id}
//                     </span>
//                     <span
//                       className="text-sm sm:text-lg font-semibold transition-colors duration-300"
//                       style={{ color: isActive ? "#ffffff" : "#ffffff" }}
//                     >
//                       {f.title}
//                     </span>
//                   </div>
//                   <ArrowUpRight
//                     className="flex-shrink-0 w-4 h-4 transition-all duration-300"
//                     style={{
//                       color: isActive ? "#ffffff" : "rgba(0,0,0,0.2)",
//                       transform: isActive ? "rotate(0deg)" : "rotate(-45deg)",
//                     }}
//                   />
//                 </div>
//                 <div
//                   className="overflow-hidden transition-all duration-500 ease-in-out"
//                   style={{ maxHeight: isActive ? "120px" : "0px", opacity: isActive ? 1 : 0 }}
//                 >
//                   <p className="mt-3 ml-9 text-md md:text-lg leading-relaxed" style={{ color: "#ffffff" ,wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal'}}>
//                     {f.desc}
//                   </p>
//                 </div>
//               </button>
//             );
//           })}
//         </div>

//           {/* Right: Video - 50% width */}
//           <div className="lg:w-1/2 flex items-start justify-center">
//           <video
//             autoPlay
//             muted
//             loop
//             playsInline
//             preload="auto"
//             className="w-full max-w-[600px] h-[400px] object-cover rounded-lg"
//           >
//             <source
//               src="https://res.cloudinary.com/djaejg3nn/video/upload/v1783599463/Pt_KCS_wywgnb.mp4"
//               type="video/mp4"
//             />
//           </video>
//           </div>

//       </div>
//     </div>
//   </section>
// );
// }

// import React, { useState } from "react";
// import { ArrowUpRight } from "lucide-react";

// const features = [
//   {
//     id: "01",
//     title: "End-to-End System Implementation",
//     desc: "Full-cycle ERP deployment from planning through go-live. We manage every phase — scoping, configuration, data migration, testing, and training — so your team transitions without disruption.",
//   },
//   {
//     id: "02",
//     title: "Strategic Process Consulting",
//     desc: "Expert guidance to align Infor capabilities with your unique business workflows. We map your operations, identify gaps, and design a solution blueprint built for long-term scalability.",
//   },
//   {
//     id: "03",
//     title: "24/7 Managed Support Services",
//     desc: "Round-the-clock monitoring, maintenance, and helpdesk for uninterrupted operations. Our dedicated team ensures your systems run at peak performance every hour of every day.",
//   },
// ];

// export default function Portfolio() {
//   const [active, setActive] = useState("01");

//   return (
//     <section className="w-full py-12 md:py-12 px-4 sm:px-6 lg:px-8 bg-[#f5f5f5]">
//       <div className="max-w-7xl mx-auto">
      
//       {/* Header */}
//       <div className="mb-12">
//         <h2 className="text-3xl sm:text-4xl xl:text-5xl font-semibold leading-[1.15] mb-10" style={{ color: "#000000" }}>
//           PT KCS Tech Infor Services Portfolio
//         </h2>
//         <p className="text-sm sm:text-lg leading-relaxed max-w-6xl" style={{ color: "#000000" }}>
//           Unlock the full potential of your enterprise with our comprehensive suite
//           of Infor services — tailored ERP systems that drive efficiency and growth.
//         </p>
//       </div>

//       {/* Accordion and Image - Side by Side */}
//       <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
        
//         {/* Left: Accordion - 50% width */}
//         <div className="lg:w-1/2">
//           {features.map((f) => {
//             const isActive = active === f.id;
//             return (
//               <button
//                 key={f.id}
//                 onClick={() => setActive(f.id)}
//                 className="w-full text-left border-b py-5 transition-all duration-300 focus:outline-none"
//                 style={{ borderColor: "rgba(0,0,0,0.08)" }}
//               >
//                 <div className="flex items-center justify-between gap-4">
//                   <div className="flex items-center gap-4">
//                     <span
//                       className="text-lg font-bold tabular-nums transition-colors duration-300"
//                       style={{ color: isActive ? "#000000" : "rgba(0,0,0,0.25)" }}
//                     >
//                       {f.id}
//                     </span>
//                     <span
//                       className="text-sm sm:text-lg font-semibold transition-colors duration-300"
//                       style={{ color: isActive ? "#000000" : "#64748b" }}
//                     >
//                       {f.title}
//                     </span>
//                   </div>
//                   <ArrowUpRight
//                     className="flex-shrink-0 w-4 h-4 transition-all duration-300"
//                     style={{
//                       color: isActive ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0.2)",
//                       transform: isActive ? "rotate(0deg)" : "rotate(-45deg)",
//                     }}
//                   />
//                 </div>
//                 <div
//                   className="overflow-hidden transition-all duration-500 ease-in-out"
//                   style={{ maxHeight: isActive ? "120px" : "0px", opacity: isActive ? 1 : 0 }}
//                 >
//                   <p className="mt-3 ml-9 text-md md:text-lg leading-relaxed" style={{ color: "#000000" ,wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal'}}>
//                     {f.desc}
//                   </p>
//                 </div>
//               </button>
//             );
//           })}
//         </div>

//         {/* Right: Image - 50% width */}
//         <div className="lg:w-1/2 flex items-start justify-center">
//           <img
//             src="https://ik.imagekit.io/7wqj9br0b/Infor/Infor_Services_Offerings.png?updatedAt=1736999085606"
//             alt="Infor Consulting Services Portfolio Infographic"
//             className="w-full max-w-[600px] h-auto object-contain"
//             style={{ minHeight: "400px" }}
//           />
//         </div>

//       </div>
//     </div>
//   </section>
// );
// }

import React from "react";
import { ArrowUpRight } from "lucide-react";

export default function Portfolio() {
  return (
    <section className="w-full py-12 md:py-12 px-4 sm:px-6 lg:px-8 bg-[#ffffff]">
      <div className="max-w-7xl mx-auto">
              {/* Label */}
        <div className="flex items-center gap-3 mb-4">
          <span
            className="inline-block w-8 h-[3px] rounded-full"
            style={{ backgroundColor: "#FF0000" }}
          />
          <span
            className="text-xs font-bold tracking-[0.2em] uppercase"
            style={{ color: "#FF0000" }}
          >
            Our Portfolio
          </span>
        </div>
      
        {/* Header */}
        <div className="mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-4xl font-semibold leading-tight mb-6" style={{ color: "#000000" }}>
            PT KCS Tech Infor Services Portfolio
          </h2>
            <p
              className="text-base sm:text-lg leading-relaxed mb-8 font-normal"
              style={{ color: "#000000", wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }}
            >
            Unlock the full potential of your enterprise with our comprehensive suite
            of Infor services — tailored ERP systems that drive efficiency and growth.
          </p>
        </div>

        {/* Content and Image - Side by Side */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          
          {/* Left: Content - 50% width */}
          <div className="lg:w-1/2">
            <div className="space-y-8">
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-3" style={{ color: "#000000" }}>
                  End-to-End System Implementation
                </h3>
            <p
              className="text-base sm:text-lg leading-relaxed mb-8 font-normal"
              style={{ color: "#000000", wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }}
            >
                  Full-cycle ERP deployment from planning through go-live. We manage every phase — scoping, 
                  configuration, data migration, testing, and training — so your team transitions without disruption.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-3" style={{ color: "#000000" }}>
                  Strategic Process Consulting
                </h3>
            <p
              className="text-base sm:text-lg leading-relaxed mb-8 font-normal"
              style={{ color: "#000000", wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }}
            >
                  Expert guidance to align Infor capabilities with your unique business workflows. We map your 
                  operations, identify gaps, and design a solution blueprint built for long-term scalability.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-3" style={{ color: "#000000" }}>
                  24/7 Managed Support Services
                </h3>
            <p
              className="text-base sm:text-lg leading-relaxed mb-8 font-normal"
              style={{ color: "#000000", wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }}
            >
                  Round-the-clock monitoring, maintenance, and helpdesk for uninterrupted operations. Our dedicated 
                  team ensures your systems run at peak performance every hour of every day.
                </p>
              </div>
            </div>
          </div>

          {/* Right: Image - 50% width */}
          <div className="lg:w-1/2 flex items-start justify-center">
            <img
              // src="https://ik.imagekit.io/7wqj9br0b/Infor/Infor_Services_Offerings.png?updatedAt=1736999085606"
              src="https://ik.imagekit.io/7wqj9br0b/PTKCS/Consulting.png"
              alt="Infor Consulting Services Portfolio Infographic"
              className="w-full max-w-[600px] h-auto object-contain"
              style={{ minHeight: "400px" }}
            />
          </div>

        </div>
      </div>
    </section>
  );
}